(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-countdown"] && !Shopify.designMode) return;
  try {
    
  const initializeComparisonCountdown = (root) => {
    if (!root || root.dataset.countdownReady === "true") return
    root.dataset.countdownReady = "true"

    const endTime = new Date(root.dataset.end).getTime()
    const timer = root.querySelector(".comparison-countdown__timer")
    const expired = root.querySelector("[data-countdown-expired]")
    const fields = {
      days: root.querySelector("[data-countdown-days]"),
      hours: root.querySelector("[data-countdown-hours]"),
      minutes: root.querySelector("[data-countdown-minutes]"),
      seconds: root.querySelector("[data-countdown-seconds]")
    }

    const render = () => {
      const remaining = endTime - Date.now()
      if (!Number.isFinite(endTime) || remaining <= 0) {
        timer.hidden = true
        expired.hidden = false
        return false
      }

      fields.days.textContent = String(Math.floor(remaining / 86400000)).padStart(2, "0")
      fields.hours.textContent = String(Math.floor((remaining / 3600000) % 24)).padStart(2, "0")
      fields.minutes.textContent = String(Math.floor((remaining / 60000) % 60)).padStart(2, "0")
      fields.seconds.textContent = String(Math.floor((remaining / 1000) % 60)).padStart(2, "0")
      return true
    }

    if (!render()) return
    const interval = window.setInterval(() => {
      if (!render()) window.clearInterval(interval)
    }, 1000)
  }

  document.querySelectorAll("[data-comparison-countdown]").forEach(initializeComparisonCountdown)
  document.addEventListener("shopify:section:load", (event) => {
    initializeComparisonCountdown(event.target.querySelector("[data-comparison-countdown]"))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-product-tabs"] && !Shopify.designMode) return;
  try {
    
  const initializeComparisonTabs = (root) => {
    if (!root || root.dataset.tabsReady === "true") return
    root.dataset.tabsReady = "true"

    const tabs = [...root.querySelectorAll("[data-comparison-tab]")]
    const panels = [...root.querySelectorAll("[data-comparison-panel]")]

    const activate = (tab, focus = false) => {
      tabs.forEach((item) => {
        const selected = item === tab
        item.classList.toggle("is-active", selected)
        item.setAttribute("aria-selected", String(selected))
        item.tabIndex = selected ? 0 : -1
      })

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute("aria-controls")
      })

      if (focus) tab.focus()
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activate(tab))
      tab.addEventListener("keydown", (event) => {
        let nextIndex
        if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length
        if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length
        if (event.key === "Home") nextIndex = 0
        if (event.key === "End") nextIndex = tabs.length - 1
        if (nextIndex === undefined) return
        event.preventDefault()
        activate(tabs[nextIndex], true)
      })
    })
  }

  document.querySelectorAll("[data-comparison-tabs]").forEach(initializeComparisonTabs)
  document.addEventListener("shopify:section:load", (event) => {
    initializeComparisonTabs(event.target.querySelector("[data-comparison-tabs]"))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-collection-circles"] && !Shopify.designMode) return;
  try {
    
  const initializeCollectionCirclesDrag = (root) => {
    if (!root || root.dataset.dragReady === "true") return

    const rail = root.querySelector("[data-collection-circles-rail]")
    if (!rail) return

    root.dataset.dragReady = "true"
    let pointerId = null
    let startX = 0
    let startScrollLeft = 0
    let didDrag = false
    let suppressClick = false

    const endDrag = (event) => {
      if (pointerId !== event.pointerId) return
      if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId)
      rail.classList.remove("is-dragging")
      suppressClick = didDrag
      pointerId = null
    }

    rail.addEventListener("pointerdown", (event) => {
      if (event.pointerType !== "mouse") return
      if (event.button !== 0) return
      if (rail.scrollWidth <= rail.clientWidth) return

      pointerId = event.pointerId
      startX = event.clientX
      startScrollLeft = rail.scrollLeft
      didDrag = false
      rail.setPointerCapture(pointerId)
      rail.classList.add("is-dragging")
    })

    rail.addEventListener("pointermove", (event) => {
      if (pointerId !== event.pointerId) return
      const distance = event.clientX - startX
      if (Math.abs(distance) > 5) didDrag = true
      if (!didDrag) return
      event.preventDefault()
      rail.scrollLeft = startScrollLeft - distance
    })

    rail.addEventListener("pointerup", endDrag)
    rail.addEventListener("pointercancel", endDrag)
    rail.addEventListener("dragstart", (event) => event.preventDefault())
    rail.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return
        event.preventDefault()
        event.stopPropagation()
        suppressClick = false
      },
      true
    )
  }

  document.querySelectorAll(".homepage-collection-circles").forEach(initializeCollectionCirclesDrag)
  document.addEventListener("shopify:section:load", (event) => {
    initializeCollectionCirclesDrag(event.target.querySelector(".homepage-collection-circles"))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  const initializeCollectionShowcaseDrag = (root) => {
    if (!root || root.dataset.dragReady === "true") return

    const rail = root.querySelector("[data-collection-showcase-rail]")
    if (!rail) return

    root.dataset.dragReady = "true"
    let pointerId = null
    let startX = 0
    let startScrollLeft = 0
    let didDrag = false
    let suppressClick = false

    const endDrag = (event) => {
      if (pointerId !== event.pointerId) return
      if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId)
      rail.classList.remove("is-dragging")
      suppressClick = didDrag
      pointerId = null
    }

    rail.addEventListener("pointerdown", (event) => {
      if (event.pointerType !== "mouse") return
      if (event.button !== 0) return
      if (!root.classList.contains("homepage-collection-showcase--mobile-scroll")) return
      if (window.matchMedia("(min-width: 990px)").matches) return

      pointerId = event.pointerId
      startX = event.clientX
      startScrollLeft = rail.scrollLeft
      didDrag = false
      rail.setPointerCapture(pointerId)
      rail.classList.add("is-dragging")
    })

    rail.addEventListener("pointermove", (event) => {
      if (pointerId !== event.pointerId) return
      const distance = event.clientX - startX
      if (Math.abs(distance) > 5) didDrag = true
      if (!didDrag) return
      event.preventDefault()
      rail.scrollLeft = startScrollLeft - distance
    })

    rail.addEventListener("pointerup", endDrag)
    rail.addEventListener("pointercancel", endDrag)
    rail.addEventListener("dragstart", (event) => event.preventDefault())
    rail.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return
        event.preventDefault()
        event.stopPropagation()
        suppressClick = false
      },
      true
    )
  }

  document.querySelectorAll(".homepage-collection-showcase").forEach(initializeCollectionShowcaseDrag)
  document.addEventListener("shopify:section:load", (event) => {
    initializeCollectionShowcaseDrag(event.target.querySelector(".homepage-collection-showcase"))
  })

  } catch(e) { console.error(e); }
})();
})();
